__turbopack_context__.v({
  "colors": "Track-module__dFOxAq__colors",
  "container": "Track-module__dFOxAq__container",
  "root": "Track-module__dFOxAq__root",
  "text": "Track-module__dFOxAq__text",
  "trackGraph": "Track-module__dFOxAq__trackGraph",
});
